export default __webpack_public_path__ + "static/media/light.f0f68091.jpg";